import type { Message, ChatContext, MessageContent, ImageMessageContent } from '../../../types/models';

type MessageRole = 'user' | 'assistant';

interface FormattedMessage {
  role: MessageRole;
  content: MessageContent;
}

function convertImageContent(content: ImageMessageContent[]): any[] {
  return content.map(item => {
    if (item.type === 'image_url' && item.image_url) {
      return {
        type: 'image',
        source: {
          type: 'url',
          media_type: 'image/jpeg',
          data: item.image_url.url
        }
      };
    }
    return {
      type: 'text',
      text: item.text || ''
    };
  });
}

function formatContent(content: MessageContent): any {
  if (typeof content === 'string') {
    return content;
  }
  return convertImageContent(content);
}

interface FormattedRequest {
  messages: FormattedMessage[];
  system?: string;
}

function buildSystemPrompt(context: ChatContext): string {
  const { userInfo } = context;
  let systemPrompt = context.systemPrompt || 'You are a helpful AI assistant. ';

  // Add user information to the context
  if (Object.keys(userInfo).length > 0) {
    systemPrompt += '\nHere is what I know about the user:\n';
    for (const [key, value] of Object.entries(userInfo)) {
      systemPrompt += `- User's ${key}: ${value}\n`;
    }
  }

  return systemPrompt;
}

export function formatMessages(
  message: string,
  context: ChatContext,
  previousMessages: Message[]
): FormattedRequest {
  // Get system prompt
  const systemPrompt = buildSystemPrompt(context);

  // Convert previous messages
  const convertedMessages: FormattedMessage[] = previousMessages.map(msg => ({
    role: msg.role === 'assistant' ? 'assistant' : 'user',
    content: formatContent(msg.content)
  }));

  // Add new message
  const messages: FormattedMessage[] = [
    ...convertedMessages,
    {
      role: 'user',
      content: formatContent(message)
    }
  ];

  return {
    messages,
    system: systemPrompt
  };
}